import React, { useState, useEffect, useRef } from 'react'
import { Control, Field, Icon } from 'Components/common/bulma'
import Autosuggest from 'react-autosuggest'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

export default function AutoComplete({
  label,
  input = {},
  error,
  showErrors,
  initialInputValue = '',
  listKey = "id",
  suggestions,
  property,
  onFetchRequested,
  onClearRequested,
  onChange = () => { console.log('Method not implemented') },
  renderSuggestion = () => { console.log('Method not implemented') },
  getSuggestionValue = () => { console.log('Method not implemented') },
}) {
  const [localValue, setLocalValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    console.log('initialInputValue', initialInputValue)
    setLocalValue(initialInputValue)
  }, [initialInputValue])

  const onLocalChange = (event, { newValue, method }) => {
    setLocalValue(newValue)

    if (!newValue) {
      onChange({
        target: {
          name: input?.name,
          value: ''
        }
      })
    }
  }

  const fetchRequested = ({ value }) => {
    setIsLoading(true);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      onFetchRequested({ query: value }).finally(() => {
        setIsLoading(false);
      });
    }, 500)
  }

  const onSuggestionSelect = (e, { suggestion }) => {
    onChange({
      target: {
        name: input?.name,
        value: suggestion[listKey],
        suggestion,
      }
    }, suggestion)
  }

  return (
    <Field>
      <label className="label">{label}</label>
      <Control className="has-icons-right">
        <Autosuggest
          suggestions={suggestions}
          inputProps={{
            value: localValue,
            onChange: onLocalChange,
            className: `input ${isLoading ? 'padding-left: 3.5rem;' : ''}`,
            placeholder: input?.placeholder,
            disabled: input?.disabled,
          }}
          onSuggestionsClearRequested={onClearRequested}
          getSuggestionValue={getSuggestionValue}
          onSuggestionsFetchRequested={fetchRequested}
          renderSuggestion={renderSuggestion}
          onSuggestionSelected={onSuggestionSelect}
        />
      {isLoading && <Icon className="is-right">
          <FontAwesomeIcon className="fa-spin" icon={faSpinner} />
      </Icon>}
      </Control>
      {(error && showErrors) && <p className="has-text-danger help">{error}</p>}
    </Field>
  )
}
